module.exports = __webpack_public_path__ + "img/m.2fede55c.jpg";